import { ActionResult, DirectoryItem } from '../types'
import { useDirectoryTree } from '../useDirectoryTree'
import { ExecutableAction } from './action'

export class MoveAction extends ExecutableAction {
  static readonly actionName = 'move'
  public readonly actionName = MoveAction.actionName

  private readonly parentId: string | undefined = undefined

  constructor(readonly items: DirectoryItem[], readonly targetDirId: string) {
    super()
    this.parentId = this.items[0]?.parentId ?? undefined
  }

  override async execute(tree: ReturnType<typeof useDirectoryTree>): Promise<ActionResult> {
    const itemIds = this.items.map((i) => i.id)
    if (!itemIds || itemIds.length === 0)
      return {
        status: 'info',
        message: 'No items selected for moving.'
      }
    try {
      const success = tree.deleteNodesByIds(itemIds)
      if (success) {
        return {
          status: 'success',
          data: undefined
        }
      } else {
        return {
          status: 'error',
          message: 'Failed to move some items.'
        }
      }
    } catch (e) {
      return {
        status: 'error',
        message: 'Failed to move items',
        error: e instanceof Error ? e : undefined
      }
    }
  }

  override async undo(tree): Promise<ActionResult> {
    if (this.parentId) {
      return new MoveAction(this.items, this.parentId).execute(tree)
    } else {
      return {
        status: 'error',
        message: 'No parent directory to move items back to.'
      }
    }
  }
}
